import produce from 'immer';

import type { EventTypeLink, LinkItem } from '@swf/generated/types/api/sports';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  dataAzLoadSuccess: (state: State, payload: EventTypeLink[]): State => ({
    ...state,
    az: payload,
    azErrorCode: undefined,
    preloaded: true
  }),
  dataAzLoadFailed: (state: State, payload: string): State => ({
    ...state,
    azErrorCode: payload,
    preloaded: true
  }),
  dataPopularSuccess: (state: State, payload: LinkItem[]): State => ({
    ...state,
    popular: payload,
    preloaded: true
  })
};
